export const ReportStepList = {
  delivery: ['step-add-information', 'step-meter-keys', 'step-comments', 'step-overviews', 'step-signature'],
  pre_inspection: ['step-add-information', 'step-comments', 'step-overviews', 'step-signature'],
  final_inspection: ['step-add-information', 'step-meter-keys', 'step-comments', 'step-overviews', 'step-signature']
}
